import React, { useMemo } from 'react';

import { Section, Grid } from '@gogame/components';
import { withForm, SidePageV2, FormField, FormFieldGroup } from '@gogame/form';

import {
  getCurrentComponent,
  getCurrentValidationSchema,
} from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm/Partners';
import {
  loadPartnerAudiences,
  loadPartners,
} from 'scenes/CustomAudiences/LookalikeAudiences/sources/fields';

import ResultFormField from './ResultFormField';
import {
  PARTNER,
  TYPE,
  TARGETING,
  ENTRIES,
  PARTNER_AUDIENCE,
} from './constants';
import {
  baseLookalikeTargetingValidationSchema,
  validationSchema,
} from './schemas';

const LookalikeAudienceForm = withForm({
  validationSchema: validationSchema,
  enableReinitialize: true,
})(
  ({
    children,
    title,
    onClose,
    onExited,
    open,
    loading,
    values,
    setFieldValue,
  }) => {
    const partner = values[PARTNER];
    const type = values[TYPE];

    let FormGroupComponent = useMemo(
      () => getCurrentComponent(values),
      [partner, type]
    );

    const targetingValidationSchema = useMemo(
      () =>
        baseLookalikeTargetingValidationSchema.concat(
          getCurrentValidationSchema(values)
        ),
      [partner, type]
    );

    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        size={'lg'}
      >
        <SidePageV2.Title title={title} />
        <SidePageV2.NewBody>
          <Section title={'General'}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <FormField.Select
                  label={'Partner'}
                  name={PARTNER}
                  source={loadPartners}
                  depends={[TYPE]}
                  withFilter={false}
                  padding={0}
                  required={true}
                  onChange={() => {
                    setFieldValue(TARGETING, {});
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <FormFieldGroup name={TARGETING}>
                  <FormField.Select
                    label={'Audience'}
                    name={PARTNER_AUDIENCE}
                    depends={[PARTNER]}
                    source={loadPartnerAudiences}
                    padding={0}
                    required={true}
                  />
                </FormFieldGroup>
              </Grid>
            </Grid>
          </Section>
          <FormGroupComponent
            name={TARGETING}
            validationSchema={targetingValidationSchema}
          />
          <ResultFormField
            name={ENTRIES}
            depends={[TARGETING, PARTNER, TYPE]}
            active={targetingValidationSchema.isValidSync(values[TARGETING])}
          />
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default LookalikeAudienceForm;
